<ion-row>
  <ion-col class="center-wrapper">
    <p class="appleColorEmoji">🎉</p>
  </ion-col>
</ion-row>
<ion-row>
  <ion-col class="center-wrapper">
    @if (type === 'conversion') {
      <p class="cash-converted">
        {{'cashout-success.Cash' | translate}} <br />
        {{'cashout-success.successfully' | translate}}
      </p>
    }
    @if (type === 'donation') {
      <p class="cash-converted">
        {{'cashout-success.Thanks' | translate}}<br />
        {{'cashout-success.donation' | translate}}
      </p>
    }
    @if (type === 'paypal') {
      <p class="cash-converted">{{'cashout-success.Cashout' | translate}}</p>
    }
  </ion-col>
</ion-row>
<ion-row>
  <ion-col class="center-wrapper">
    @if (type === 'conversion') {
      <p class="credit-updated">
        {{'cashout-success.credit' | translate}}<br />
        {{'cashout-success.int_updated' | translate}}@if (balance$ | async; as balance) {
        <span>{{currencySymbol}}
        {{ (balance?.preferred_currency?.credit ?? balance?.credit ?? 0) | displayCurrency }}</span>
      }
    </p>
  }
  @if (type === 'donation') {
    <p class="credit-updated">
      {{'cashout-success.Your' | translate}} <br />
      {{'cashout-success.matching' | translate}}
    </p>
  }
  @if (type === 'paypal') {
    <p class="credit-updated">
      {{'cashout-success.processed' | translate}} <br />
      {{'cashout-success.within' | translate}}
    </p>
  }
</ion-col>
</ion-row>
<ion-row class="credit-row">
  <ion-col class="center-wrapper">
    @if (type === 'conversion') {
      <ion-button class="credit-btn" (click)="closeAndRedirect('conversion')">
        {{'cashout-success.Use' | translate}}
      </ion-button>
    }
    @if (type === 'paypal') {
      <ion-button class="credit-btn" (click)="closeAndRedirect('paypal')">
        {{'cashout-success.View' | translate}}
      </ion-button>
    }
  </ion-col>
</ion-row>
<ion-row>
  <ion-col class="center-wrapper">
    <p class="back-to-account" (click)="closeAndRedirect('account')">{{'cashout-success.Back' | translate}}</p>
  </ion-col>
</ion-row>